<template>
  <div class="feed-container">
    <h2>Noutăți</h2>
    
    <div v-if="loading" class="loading-message">
      <p>Se încarcă postările...</p>
    </div>
    
    <div v-else-if="error" class="error-message">
      <p>{{ error }}</p>
    </div>
    
    <div v-else-if="posts.length > 0" class="posts-list">
      <PostCard
        v-for="post in posts"
        :key="post.id"
        :post="post"
        @post-deleted="handlePostDeleted" 
      />
    </div>

    <div v-else class="empty-message">
      <p>Momentan nu sunt noutăți de afișat.</p>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import apiClient from '@/api.js';
import PostCard from './PostCard.vue'; // <-- Importăm componenta noastră PostCard

// Definim stările reactive
const posts = ref([]);
const loading = ref(true);
const error = ref(null);

// Funcția care încarcă postările de la API
const fetchPosts = async () => {
  try {
    loading.value = true;
    const response = await apiClient.get('/posts');
    posts.value = response.data; // Salvăm postările în starea noastră
  } catch (err) {
    console.error("Eroare la preluarea postărilor:", err);
    error.value = "Nu s-au putut încărca postările. Te rugăm să încerci din nou.";
  } finally {
    loading.value = false;
  }
};

// Funcția care șterge o postare din listă (fără refresh la pagină)
// Este apelată de @post-deleted de mai sus
const handlePostDeleted = (deletedPostId) => {
  console.log('Postarea cu ID-ul', deletedPostId, 'a fost ștearsă. Se actualizează UI-ul.');
  // Filtrăm lista locală pentru a scoate postarea ștearsă
  posts.value = posts.value.filter(post => post.id !== deletedPostId);
};

// Încărcăm postările când componenta este montată
onMounted(fetchPosts);
</script>

<style scoped>
.feed-container {
  max-width: 600px;
  margin: 20px auto; /* Centrează feed-ul pe pagină */
  padding: 0 10px;
}

.feed-container h2 {
  color: #0E3035;
  border-bottom: 2px solid #eee;
  padding-bottom: 10px;
  margin-bottom: 20px;
}

.loading-message, .error-message, .empty-message {
  text-align: center;
  font-size: 1.1em;
  color: #777;
  padding: 40px 0;
}

.error-message {
  color: #C0392B;
}

.posts-list {
  display: flex;
  flex-direction: column;
  gap: 20px; /* Adaugă spațiu între PostCard-uri */
}
</style>